<template>
    <Card :title="$t('labels.main_information')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.image')">
                        <ImageInputGroup v-model:image="picture" type="user-picture"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.full_name')" required>
                        <Input v-model="fullName"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.phone')">
                        <Input :model-value="phone" readonly/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.email')">
                        <Input :model-value="profile.email" readonly/>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex flex-wrap justify-content-end card-footer-actions">
            <button class="btn btn-link" @click="connectMcp">
                <i class="icon-puzzle4 mr-2"></i>
                {{ $t('buttons.connect_mcp') }}
            </button>
            <Button color="indigo" @click="save">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.save') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import ImageInputGroup from '../../../components/input/ImageInputGroup.vue';

import { Mask } from 'maska';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';
import { mapGetters } from 'vuex';

const MCP_URL = 'https://mcp.fasunok.support/';

export default {
    name: 'ProfileEditPage',
    components: {
        Card, FormGroup, Input, Button, ImageInputGroup
    },
    data() {
        return {
            fullName: '',
            picture: null
        }
    },
    computed: {
        ...mapGetters('profile', ['profile']),
        phone() {
            if (!this.profile?.phone) {
                return '';
            }

            return new Mask({ mask: '+38 (###) ###-##-##' }).masked(this.profile.phone);
        }
    },
    methods: {
        connectMcp() {
            window.open(MCP_URL, '_blank');
        },
        async save() {
            await httpClient.patch('/profile', {
                full_name: this.fullName,
                picture_uuid: this.picture?.uuid
            });

            await this.$store.dispatch('profile/fetchProfile');

            new MessageNotificator().success(this.$t('alerts.success'));
        }
    },
    watch: {
        profile: {
            handler(profile) {
                this.fullName = profile?.full_name ?? '';
                this.picture = profile?.picture ?? null;
            },
            immediate: true
        }
    }
}
</script>
<style scoped>
.card-footer-actions {
    gap: .5rem;
}
</style>
